export const PROGRESS_INDICATOR_TRANSITION_TIME_IN_MS = 100;
